// export default [
//   '2021-01-01',
//   '2021-01-02',
//   '2021-01-03',
//   '2021-01-09',
//   '2021-01-10',
//   '2021-01-16',
//   '2021-01-17',
//   '2021-01-23',
//   '2021-01-24',
//   '2021-01-30',
//   '2021-01-31',
//   '2021-02-06',
//   '2021-02-07',
//   '2021-02-10',
//   '2021-02-11',
//   '2021-02-12',
//   '2021-02-13',
//   '2021-02-14',
//   '2021-02-15',
//   '2021-02-16',
//   '2021-02-21',
//   '2021-02-27',
//   '2021-02-28',
//   '2021-03-01',
//   '2021-03-06',
//   '2021-03-07',
//   '2021-03-13',
//   '2021-03-14',
//   '2021-03-20',
//   '2021-03-21',
//   '2021-03-27',
//   '2021-03-28',
//   '2021-04-02',
//   '2021-04-03',
//   '2021-04-04',
//   '2021-04-05',
//   '2021-04-10',
//   '2021-04-11',
//   '2021-04-17',
//   '2021-04-18',
//   '2021-04-24',
//   '2021-04-25',
//   '2021-05-01',
//   '2021-05-02',
//   '2021-05-08',
//   '2021-05-09',
//   '2021-05-15',
//   '2021-05-16',
//   '2021-05-22',
//   '2021-05-23',
//   '2021-05-29',
//   '2021-05-30',
//   '2021-06-05',
//   '2021-06-06',
//   '2021-06-12',
//   '2021-06-13',
//   '2021-06-14',
//   '2021-06-19',
//   '2021-06-20',
//   '2021-06-26',
//   '2021-06-27',
//   '2021-07-03',
//   '2021-07-04',
//   '2021-07-10',
//   '2021-07-11',
//   '2021-07-17',
//   '2021-07-18',
//   '2021-07-24',
//   '2021-07-25',
//   '2021-07-31',
//   '2021-08-01',
//   '2021-08-07',
//   '2021-08-08',
//   '2021-08-14',
//   '2021-08-15',
//   '2021-08-21',
//   '2021-08-22',
//   '2021-08-28',
//   '2021-08-29',
//   '2021-09-04',
//   '2021-09-05',
//   '2021-09-12',
//   '2021-09-18',
//   '2021-09-19',
//   '2021-09-20',
//   '2021-09-21',
//   '2021-09-25',
//   '2021-09-26',
//   '2021-10-02',
//   '2021-10-03',
//   '2021-10-09',
//   '2021-10-10',
//   '2021-10-11',
//   '2021-10-16',
//   '2021-10-17',
//   '2021-10-23',
//   '2021-10-24',
//   '2021-10-30',
//   '2021-10-31',
//   '2021-11-06',
//   '2021-11-07',
//   '2021-11-13',
//   '2021-11-14',
//   '2021-11-20',
//   '2021-11-21',
//   '2021-11-27',
//   '2021-11-28',
//   '2021-12-04',
//   '2021-12-05',
//   '2021-12-11',
//   '2021-12-12',
//   '2021-12-18',
//   '2021-12-19',
//   '2021-12-25',
//   '2021-12-26',
//   '2021-12-31',
//   '2022-01-01',
//   '2022-01-02',
//   '2022-01-08',
//   '2022-01-09',
//   '2022-01-15',
//   '2022-01-16',
//   '2022-01-23',
//   '2022-01-29',
//   '2022-01-30',
//   '2022-01-31',
//   '2022-02-01',
//   '2022-02-02',
//   '2022-02-03',
//   '2022-02-04',
//   '2022-02-05',
//   '2022-02-06',
//   '2022-02-12',
//   '2022-02-13',
//   '2022-02-19',
//   '2022-02-20',
//   '2022-02-26',
//   '2022-02-27',
//   '2022-02-28',
//   '2022-03-05',
//   '2022-03-06',
//   '2022-03-12',
//   '2022-03-13',
//   '2022-03-19',
//   '2022-03-20',
//   '2022-03-26',
//   '2022-03-27',
//   '2022-04-02',
//   '2022-04-03',
//   '2022-04-04',
//   '2022-04-05',
//   '2022-04-09',
//   '2022-04-10',
//   '2022-04-16',
//   '2022-04-17',
//   '2022-04-23',
//   '2022-04-24',
//   '2022-04-30',
//   '2022-05-01',
//   '2022-05-02',
//   '2022-05-07',
//   '2022-05-08',
//   '2022-05-14',
//   '2022-05-15',
//   '2022-05-21',
//   '2022-05-22',
//   '2022-05-28',
//   '2022-05-29',
//   '2022-06-03',
//   '2022-06-04',
//   '2022-06-05',
//   '2022-06-11',
//   '2022-06-12',
//   '2022-06-18',
//   '2022-06-19',
//   '2022-06-25',
//   '2022-06-26',
//   '2022-07-02',
//   '2022-07-03',
//   '2022-07-09',
//   '2022-07-10',
//   '2022-07-16',
//   '2022-07-17',
//   '2022-07-23',
//   '2022-07-24',
//   '2022-07-30',
//   '2022-07-31',
//   '2022-08-06',
//   '2022-08-07',
//   '2022-08-13',
//   '2022-08-14',
//   '2022-08-20',
//   '2022-08-21',
//   '2022-08-27',
//   '2022-08-28',
//   '2022-09-03',
//   '2022-09-04',
//   '2022-09-09',
//   '2022-09-10',
//   '2022-09-11',
//   '2022-09-17',
//   '2022-09-18',
//   '2022-09-24',
//   '2022-09-25',
//   '2022-10-01',
//   '2022-10-02',
//   '2022-10-08',
//   '2022-10-09',
//   '2022-10-10',
//   '2022-10-15',
//   '2022-10-16',
//   '2022-10-22',
//   '2022-10-23',
//   '2022-10-29',
//   '2022-10-30',
//   '2022-11-05',
//   '2022-11-06',
//   '2022-11-12',
//   '2022-11-13',
//   '2022-11-19',
//   '2022-11-20',
//   '2022-11-26',
//   '2022-11-27',
//   '2022-12-03',
//   '2022-12-04',
//   '2022-12-10',
//   '2022-12-11',
//   '2022-12-17',
//   '2022-12-18',
//   '2022-12-24',
//   '2022-12-25',
//   '2022-12-31',
// ].reduce((ds, d) => ({ ...ds, d: new Date(d) }), {});

export default [
  '2021-01-01',
  '2021-01-02',
  '2021-01-03',
  '2021-01-09',
  '2021-01-10',
  '2021-01-16',
  '2021-01-17',
  '2021-01-23',
  '2021-01-24',
  '2021-01-30',
  '2021-01-31',
  '2021-02-06',
  '2021-02-07',
  '2021-02-10',
  '2021-02-11',
  '2021-02-12',
  '2021-02-13',
  '2021-02-14',
  '2021-02-15',
  '2021-02-16',
  '2021-02-21',
  '2021-02-27',
  '2021-02-28',
  '2021-03-01',
  '2021-03-06',
  '2021-03-07',
  '2021-03-13',
  '2021-03-14',
  '2021-03-20',
  '2021-03-21',
  '2021-03-27',
  '2021-03-28',
  '2021-04-02',
  '2021-04-03',
  '2021-04-04',
  '2021-04-05',
  '2021-04-10',
  '2021-04-11',
  '2021-04-17',
  '2021-04-18',
  '2021-04-24',
  '2021-04-25',
  '2021-05-01',
  '2021-05-02',
  '2021-05-08',
  '2021-05-09',
  '2021-05-15',
  '2021-05-16',
  '2021-05-22',
  '2021-05-23',
  '2021-05-29',
  '2021-05-30',
  '2021-06-05',
  '2021-06-06',
  '2021-06-12',
  '2021-06-13',
  '2021-06-14',
  '2021-06-19',
  '2021-06-20',
  '2021-06-26',
  '2021-06-27',
  '2021-07-03',
  '2021-07-04',
  '2021-07-10',
  '2021-07-11',
  '2021-07-17',
  '2021-07-18',
  '2021-07-24',
  '2021-07-25',
  '2021-07-31',
  '2021-08-01',
  '2021-08-07',
  '2021-08-08',
  '2021-08-14',
  '2021-08-15',
  '2021-08-21',
  '2021-08-22',
  '2021-08-28',
  '2021-08-29',
  '2021-09-04',
  '2021-09-05',
  '2021-09-12',
  '2021-09-18',
  '2021-09-19',
  '2021-09-20',
  '2021-09-21',
  '2021-09-25',
  '2021-09-26',
  '2021-10-02',
  '2021-10-03',
  '2021-10-09',
  '2021-10-10',
  '2021-10-11',
  '2021-10-16',
  '2021-10-17',
  '2021-10-23',
  '2021-10-24',
  '2021-10-30',
  '2021-10-31',
  '2021-11-06',
  '2021-11-07',
  '2021-11-13',
  '2021-11-14',
  '2021-11-20',
  '2021-11-21',
  '2021-11-27',
  '2021-11-28',
  '2021-12-04',
  '2021-12-05',
  '2021-12-11',
  '2021-12-12',
  '2021-12-18',
  '2021-12-19',
  '2021-12-25',
  '2021-12-26',
  '2021-12-31',
  '2022-01-01',
  '2022-01-02',
  '2022-01-08',
  '2022-01-09',
  '2022-01-15',
  '2022-01-16',
  '2022-01-23',
  '2022-01-29',
  '2022-01-30',
  '2022-01-31',
  '2022-02-01',
  '2022-02-02',
  '2022-02-03',
  '2022-02-04',
  '2022-02-05',
  '2022-02-06',
  '2022-02-12',
  '2022-02-13',
  '2022-02-19',
  '2022-02-20',
  '2022-02-26',
  '2022-02-27',
  '2022-02-28',
  '2022-03-05',
  '2022-03-06',
  '2022-03-12',
  '2022-03-13',
  '2022-03-19',
  '2022-03-20',
  '2022-03-26',
  '2022-03-27',
  '2022-04-02',
  '2022-04-03',
  '2022-04-04',
  '2022-04-05',
  '2022-04-09',
  '2022-04-10',
  '2022-04-16',
  '2022-04-17',
  '2022-04-23',
  '2022-04-24',
  '2022-04-30',
  '2022-05-01',
  '2022-05-02',
  '2022-05-07',
  '2022-05-08',
  '2022-05-14',
  '2022-05-15',
  '2022-05-21',
  '2022-05-22',
  '2022-05-28',
  '2022-05-29',
  '2022-06-03',
  '2022-06-04',
  '2022-06-05',
  '2022-06-11',
  '2022-06-12',
  '2022-06-18',
  '2022-06-19',
  '2022-06-25',
  '2022-06-26',
  '2022-07-02',
  '2022-07-03',
  '2022-07-09',
  '2022-07-10',
  '2022-07-16',
  '2022-07-17',
  '2022-07-23',
  '2022-07-24',
  '2022-07-30',
  '2022-07-31',
  '2022-08-06',
  '2022-08-07',
  '2022-08-13',
  '2022-08-14',
  '2022-08-20',
  '2022-08-21',
  '2022-08-27',
  '2022-08-28',
  '2022-09-03',
  '2022-09-04',
  '2022-09-09',
  '2022-09-10',
  '2022-09-11',
  '2022-09-17',
  '2022-09-18',
  '2022-09-24',
  '2022-09-25',
  '2022-10-01',
  '2022-10-02',
  '2022-10-08',
  '2022-10-09',
  '2022-10-10',
  '2022-10-15',
  '2022-10-16',
  '2022-10-22',
  '2022-10-23',
  '2022-10-29',
  '2022-10-30',
  '2022-11-05',
  '2022-11-06',
  '2022-11-12',
  '2022-11-13',
  '2022-11-19',
  '2022-11-20',
  '2022-11-26',
  '2022-11-27',
  '2022-12-03',
  '2022-12-04',
  '2022-12-10',
  '2022-12-11',
  '2022-12-17',
  '2022-12-18',
  '2022-12-24',
  '2022-12-25',
  '2022-12-31',
  '2023-01-01',
  '2023-01-02',
  '2023-01-08',
  '2023-01-14',
  '2023-01-15',
  '2023-01-20',
  '2023-01-21',
  '2023-01-22',
  '2023-01-23',
  '2023-01-24',
  '2023-01-25',
  '2023-01-26',
  '2023-01-27',
  '2023-01-28',
  '2023-01-29',
  '2023-02-05',
  '2023-02-11',
  '2023-02-12',
  '2023-02-19',
  '2023-02-25',
  '2023-02-26',
  '2023-02-27',
  '2023-02-28',
  '2023-03-04',
  '2023-03-05',
  '2023-03-11',
  '2023-03-12',
  '2023-03-18',
  '2023-03-19',
  '2023-03-26',
  '2023-04-01',
  '2023-04-02',
  '2023-04-03',
  '2023-04-04',
  '2023-04-05',
  '2023-04-08',
  '2023-04-09',
  '2023-04-15',
  '2023-04-16',
  '2023-04-22',
  '2023-04-23',
  '2023-04-29',
  '2023-04-30',
  '2023-05-06',
  '2023-05-07',
  '2023-05-13',
  '2023-05-14',
  '2023-05-20',
  '2023-05-21',
  '2023-05-27',
  '2023-05-28',
  '2023-06-03',
  '2023-06-04',
  '2023-06-10',
  '2023-06-11',
  '2023-06-18',
  '2023-06-22',
  '2023-06-23',
  '2023-06-24',
  '2023-06-25',
  '2023-07-01',
  '2023-07-02',
  '2023-07-08',
  '2023-07-09',
  '2023-07-15',
  '2023-07-16',
  '2023-07-22',
  '2023-07-23',
  '2023-07-29',
  '2023-07-30',
  '2023-08-05',
  '2023-08-06',
  '2023-08-12',
  '2023-08-13',
  '2023-08-19',
  '2023-08-20',
  '2023-08-26',
  '2023-08-27',
  '2023-09-02',
  '2023-09-03',
  '2023-09-09',
  '2023-09-10',
  '2023-09-16',
  '2023-09-17',
  '2023-09-24',
  '2023-09-29',
  '2023-09-30',
  '2023-10-01',
  '2023-10-07',
  '2023-10-08',
  '2023-10-09',
  '2023-10-10',
  '2023-10-14',
  '2023-10-15',
  '2023-10-21',
  '2023-10-22',
  '2023-10-28',
  '2023-10-29',
  '2023-11-04',
  '2023-11-05',
  '2023-11-11',
  '2023-11-12',
  '2023-11-18',
  '2023-11-19',
  '2023-11-25',
  '2023-11-26',
  '2023-12-02',
  '2023-12-03',
  '2023-12-09',
  '2023-12-10',
  '2023-12-16',
  '2023-12-17',
  '2023-12-23',
  '2023-12-24',
  '2023-12-30',
  '2023-12-31',
];
